// extracted by mini-css-extract-plugin
export default {"card":"styles_card__3AW7J","body":"styles_body__lmWqV"};